import { Configuration, MechanicalKilnAuditApi } from '@rhim/rest/mechanicalkilnaudit';

/**
 * "https://apim-apo-dev.azure-api.net/wearmanagement/v1".replace(/\/+$/, "");
 */
const BASE_URL = '/api/mechanicalkilnauditservice/v1';

const configuration: Configuration = {} as Configuration;

export const mechanicalKilnAudit = new MechanicalKilnAuditApi(configuration, BASE_URL);
